import { axios } from "../../lib/axios";

export type PatchQuizPayload = {
  isDemo?: boolean;
  title?: string;
};

export const PatchQuiz = (id: string, payload: PatchQuizPayload) => {
  return axios.patch(`/quiz/${id}`, payload).then((res) => res.data);
};
